/* What a sentence typed or spoken into the search box asks for (24 Oct 2026, mock Four_1
   change 7): "రేపు ఉదయం తిరుపతికి 7 సీటర్ కావాలి" is a 7-seater, to Tirupati, tomorrow
   morning - not the words to find in a car's name. Read with plain rules, in all five
   languages, on the phone: no request, no cost, nothing sent anywhere.

   A place is matched by the start of a word, so the endings a language adds - తిరుపతికి,
   திருப்பதிக்கு, ತಿರುಪತಿಗೆ, "तिरुपति के लिए" - still name Tirupati. The answer is used only
   when it is clearly a request: a place, or two or more things asked for. */

import { SEASON_TRIPS } from "../data/seasonTrips";
import { CITY_LIST_AP } from "./cities";
import { CITY_NATIVE } from "./localNameWords";

const norm = (s) => String(s || "").toLowerCase().replace(/[.,!?।]+/g, " ").replace(/\s+/g, " ").trim();
const any = (text, words) => words.some((w) => text.includes(w));

const NUM_WORDS = {
  4: ["four", "నాలుగు", "चार", "நான்கு", "ನಾಲ್ಕು"], 5: ["five", "ఐదు", "पांच", "पाँच", "ஐந்து", "ಐದು"],
  6: ["six", "ఆరు", "छह", "ஆறு", "ಆರು"], 7: ["seven", "ఏడు", "सात", "ஏழு", "ಏಳು"],
  8: ["eight", "ఎనిమిది", "आठ", "எட்டு", "ಎಂಟು"], 12: ["twelve", "పన్నెండు", "बारह", "பன்னிரண்டு", "ಹನ್ನೆರಡು"],
};
const SEAT_WORDS = "(?:seater|seats?|సీటర్|సీట్లు|సీట్ల|सीटर|सीट|சீட்டர்|இருக்கை|ಸೀಟರ್|ಸೀಟು|ಸೀಟ್)";

const CAR_TYPE_WORDS = [
  ["Tempo Traveller", ["tempo", "traveller", "టెంపో", "टेम्पो", "டெம்போ", "ಟೆಂಪೋ"]],
  ["Bus", ["bus", "బస్", "बस", "பேருந்து", "ಬಸ್"]],
  ["Mini SUV", ["mini suv", "మినీ ఎస్‌యూవీ", "मिनी एसयूवी"]],
  ["SUV", ["suv", "ఎస్‌యూవీ", "एसयूवी", "எஸ்யூவி", "ಎಸ್‌ಯುವಿ"]],
  ["Sedan", ["sedan", "సెడాన్", "सेडान", "செடான்", "ಸೆಡಾನ್"]],
  ["Hatchback", ["hatchback", "హ్యాచ్‌బ్యాక్", "हैचबैक", "ஹேட்ச்பேக்", "ಹ್ಯಾಚ್‌ಬ್ಯಾಕ್"]],
];
const FUEL_WORDS = [
  ["Diesel", ["diesel", "డీజిల్", "डीजल", "டீசல்", "ಡೀಸೆಲ್"]],
  ["Petrol", ["petrol", "పెట్రోల్", "पेट्रोल", "பெட்ரோல்", "ಪೆಟ್ರೋಲ್"]],
  ["CNG", ["cng", "సీఎన్‌జీ", "सीएनजी", "சிஎன்ஜி", "ಸಿಎನ್‌ಜಿ"]],
  ["EV", ["electric", " ev", "ఎలక్ట్రిక్", "इलेक्ट्रिक", "மின்சார", "ಎಲೆಕ್ಟ್ರಿಕ್"]],
];
// "Hindi speaking driver" - the language the driver speaks, only with a speaking word.
const LANG_WORDS = [
  ["Hindi", ["hindi", "హిందీ", "हिंदी", "हिन्दी", "ஹிந்தி", "ಹಿಂದಿ"]],
  ["English", ["english", "ఇంగ్లీష్", "इंग्लिश", "अंग्रेज़ी", "ஆங்கில", "ಇಂಗ್ಲಿಷ್"]],
  ["Tamil", ["tamil", "తమిళం", "तमिल", "தமிழ்", "ತಮಿಳು"]],
  ["Kannada", ["kannada", "కన్నడ", "कन्नड़", "கன்னட", "ಕನ್ನಡ"]],
  ["Telugu", ["telugu", "తెలుగు", "तेलुगु", "தெலுங்கு", "ತೆಲುಗು"]],
];
const SPEAK_WORDS = ["speak", "speaking", "మాట్లాడే", "మాట్లాడగల", "बोलने", "बोलता", "பேசும்", "ಮಾತನಾಡುವ"];

const DAY_WORDS = [
  [2, ["day after tomorrow", "ఎల్లుండి", "परसों", "நாளை மறுநாள்", "ನಾಡಿದ್ದು"]],
  [1, ["tomorrow", "రేపు", "कल", "நாளை", "ನಾಳೆ"]],
  [0, ["today", "tonight", "ఈరోజు", "ఇవాళ", "ఈ రోజు", "आज", "இன்று", "ಇಂದು"]],
];
const TIME_WORDS = [
  ["05:00", ["early morning", "తెల్లవారుజామున", "तड़के", "அதிகாலை", "ಮುಂಜಾನೆ"]],
  ["06:00", ["morning", "ఉదయం", "పొద్దున్న", "పొద్దున", "सुबह", "காலை", "ಬೆಳಿಗ್ಗೆ"]],
  ["13:00", ["afternoon", "మధ్యాహ్నం", "दोपहर", "மதியம்", "ಮಧ್ಯಾಹ್ನ"]],
  ["17:00", ["evening", "సాయంత్రం", "शाम", "மாலை", "ಸಂಜೆ"]],
  ["21:00", ["night", "tonight", "రాత్రి", "रात", "இரவு", "ರಾತ್ರಿ"]],
];
const ROUND_WORDS = ["round trip", "return", "up and down", "and back", "వెళ్ళి రా", "వెళ్లి రా", "వెళ్ళి వచ్చ", "వెళ్లి వచ్చ", "రౌండ్", "आना-जाना", "आना जाना", "वापसी", "போய் வர", "சென்று திரும்ப", "ಹೋಗಿ ಬರ"];
const DROP_WORDS = ["drop", "one way", "oneway", "దింపాలి", "దించాలి", "దిగబెట్ట", "డ్రాప్", "छोड़ना", "छोड़", "ड्रॉप", "இறக்கி", "ட்ராப்", "ಬಿಡಲು", "ಡ್ರಾಪ್"];
const AIRPORT_WORDS = ["airport", "ఎయిర్‌పోర్ట్", "ఎయిర్ పోర్ట్", "విమానాశ్రయ", "एयरपोर्ट", "हवाई अड्डा", "விமான நிலைய", "ஏர்போர்ட்", "ಏರ್‌ಪೋರ್ಟ್", "ವಿಮಾನ ನಿಲ್ದಾಣ"];
const HYD_WORDS = ["hyderabad", "hyd", "హైదరాబాద్", "శంషాబాద్", "हैदराबाद", "ஹைதராபாத்", "ಹೈದರಾಬಾದ್"];

// Each trip and each city under the names a reader may use, longest first so
// "హైదరాబాద్ విమానాశ్రయం" wins over "హైదరాబాద్".
const PLACES = (() => {
  const out = [];
  for (const t of SEASON_TRIPS) {
    if (/sankranti/.test(t.slug)) continue;
    const names = new Set([...Object.values(t.name || {}), ...Object.values(t.dest || {}), t.abbr, t.slug.replace(/-/g, " ")].filter(Boolean));
    for (const n of names) out.push({ name: norm(n), trip: t });
  }
  for (const c of CITY_LIST_AP) {
    for (const n of [c, ...(CITY_NATIVE[c] || [])]) out.push({ name: norm(n), city: c });
  }
  return out.filter((p) => p.name.length >= 3).sort((a, b) => b.name.length - a.name.length);
})();

const findPlace = (text) => {
  const words = text.split(" ");
  for (const p of PLACES) {
    const n = p.name;
    if (n.includes(" ") ? text.includes(n) : words.some((w) => w === n || (w.startsWith(n) && w.length - n.length <= 8))) return p;
  }
  return null;
};

/** What the words ask for; null when they are just words to search for. */
export function parseQuery(raw, { home = "Vijayawada" } = {}) {
  const text = ` ${norm(raw)} `;
  if (text.trim().length < 3) return null;
  const out = { seats: null, carType: null, fuel: null, language: null, trip: null, city: null, day: null, time: null, tripType: null };

  const seatNum = text.match(new RegExp(`(\\d{1,2})\\s*-?\\s*${SEAT_WORDS}`));
  if (seatNum) out.seats = Number(seatNum[1]);
  else for (const [n, words] of Object.entries(NUM_WORDS)) {
    if (words.some((w) => new RegExp(`${w}\\s*${SEAT_WORDS}`).test(text))) { out.seats = Number(n); break; }
  }
  for (const [v, words] of CAR_TYPE_WORDS) if (any(text, words)) { out.carType = v; break; }
  for (const [v, words] of FUEL_WORDS) if (any(text, words)) { out.fuel = v; break; }
  if (any(text, SPEAK_WORDS)) for (const [v, words] of LANG_WORDS) if (any(text, words)) { out.language = v; break; }
  for (const [d, words] of DAY_WORDS) if (any(text, words)) { out.day = d; break; }
  const clock = text.match(/\b(\d{1,2})(?::(\d{2}))?\s*(am|pm)\b/);
  if (clock) {
    let h = Number(clock[1]) % 12; if (clock[3] === "pm") h += 12;
    out.time = `${String(h).padStart(2, "0")}:${clock[2] || "00"}`;
  } else for (const [v, words] of TIME_WORDS) if (any(text, words)) { out.time = v; break; }
  if (any(text, ROUND_WORDS)) out.tripType = "ROUND";
  else if (any(text, DROP_WORDS)) out.tripType = "ONE_WAY";

  // The place: the airport first (Hyderabad's or ours), then a trip, then a city.
  const byslug = (s) => SEASON_TRIPS.find((t) => t.slug === s);
  if (any(text, AIRPORT_WORDS)) out.trip = byslug(any(text, HYD_WORDS) ? "hyderabad-airport" : "gannavaram-airport");
  else {
    const p = findPlace(text.trim());
    if (p?.trip) out.trip = p.trip;
    else if (p?.city && p.city !== home) out.city = p.city;
  }
  if (out.trip && !out.tripType) out.tripType = out.trip.type === "ONE_WAY" ? "ONE_WAY" : "ROUND";

  const asked = ["seats", "carType", "fuel", "language", "day", "time", "tripType"].filter((k) => out[k] != null).length;
  if (!out.trip && !out.city && asked < 2) return null;
  return out;
}

/** Where the trip goes, as the trip forms hold a place. */
export const intentDrop = (intent) => {
  if (intent?.trip?.to) return { value: intent.trip.to, selected: true };
  if (intent?.city) return { value: `${intent.city}, India`, selected: true };
  return null;
};

/** "2026-10-25T06:00" for the day and time asked for - tomorrow 6 am when only a day is
    given, and nothing when neither is. */
export function intentWhen(intent, now = new Date()) {
  if (intent?.day == null && !intent?.time) return "";
  const d = new Date(now);
  d.setDate(d.getDate() + (intent.day ?? (intent.time ? 0 : 1)));
  const [h, m] = (intent.time || "06:00").split(":").map(Number);
  d.setHours(h, m, 0, 0);
  // A time today that has already gone is tomorrow.
  if (intent.day == null && d.getTime() < now.getTime() + 30 * 60000) d.setDate(d.getDate() + 1);
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}T${p(d.getHours())}:${p(d.getMinutes())}`;
}
